export default "__VITE_ASSET___NilBAnZ__"